export const NAME = "orders/pay/info";
